import { render, staticRenderFns } from "./ModalOrcamento.vue?vue&type=template&id=db8c3d5c&scoped=true"
import script from "./ModalOrcamento.vue?vue&type=script&lang=js"
export * from "./ModalOrcamento.vue?vue&type=script&lang=js"
import style0 from "./ModalOrcamento.vue?vue&type=style&index=0&id=db8c3d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8c3d5c",
  null
  
)

export default component.exports